import { Card, Typography, Empty, Button } from 'antd'
import { BarChartOutlined, FileSearchOutlined } from '@ant-design/icons'

const { Title, Paragraph } = Typography

export function ReportsPage() {
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Reports & Analytics
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          View assessment results and generate insights
        </Paragraph>
      </div>

      <Card>
        <Empty
          image={<BarChartOutlined style={{ fontSize: 64, color: '#722ed1' }} />}
          description={
            <div>
              <Title level={4}>No Reports Generated</Title>
              <Paragraph type="secondary">
                Generate reports from your assessment data to gain insights and track trends
              </Paragraph>
            </div>
          }
        >
          <Button type="primary" icon={<FileSearchOutlined />} size="large">
            Generate Report
          </Button>
        </Empty>
      </Card>
    </div>
  )
}

